import { useEffect } from 'react';
import {
  Button,
  IconButton,
  Navbar,
  Text,
} from '@resultadosdigitais/tangram-components';
import { Times } from '@resultadosdigitais/tangram-react-icons';
import { Outlet } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import { Avatar } from './components/avatar';
import { Balloon } from './components/balloon';
import { Indicator } from './components/indicator';
import { useAgent } from './context/agent';
import { useUI } from './context/ui';

const WidgetWindow = styled.div<{ open: boolean }>`
  display: ${(props) => (props.open ? 'flex' : 'none')};
  background-color: #ffffff;
  flex-direction: column;
  flex: 1;
  width: 100%;
  position: relative;
  border: 1px solid var(--neutral-border);
  z-index: 1;
`;

const WidgetWindowMain = styled.div<{ open: boolean }>`
  display: flex;
  flex-direction: column;
`;

const WidgetLauncher = styled.div<{ left: boolean }>`
  user-select: none;
  flex: none;
  position: absolute;
  ${(props) => (props.left ? 'left: 24px;' : 'right: 24px;')}
  display: flex;
  ${(props) =>
    props.left ? 'flex-direction: row-reverse;' : 'flex-direction: row;'}
  align-items: flex-end;
  bottom: 24px;
  gap: var(--size-spacing-04);
`;

const WidgetContainer = styled.div`
  min-height: 100vh;
  align-items: end;
  justify-content: end;
`;

// widget avatar animation
const widgetZoomIn = keyframes`
  0%   {scale: 0;}
  60%  {scale: 1.2;}
  100% {scale: 1;}
`;

const WidgetAvatar = styled(Avatar)`
  width: 60px;
  height: 60px;
  font-size: 22px;
  scale: 0;
  animation-name: ${widgetZoomIn};
  animation-delay: 0.5s;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.15);
  }
`;

const Close = () => {
  const { setUI } = useUI();
  return (
    <IconButton
      kind={Button.kinds.tertiary}
      onClick={() => {
        setUI((ui) => ({ ...ui, open: false }));
      }}
    >
      <Times title="Close" />
    </IconButton>
  );
};

export function Component() {
  const { ui, setUI } = useUI();
  const agent = useAgent();

  useEffect(() => {
    setUI((ui) => ({ ...ui, left: agent.left }));
  }, []);

  return (
    <WidgetContainer>
      <WidgetWindow open={ui.open}>
        <Navbar
          style={{
            border: '1px solid var(--neutral-border)',
            paddingRight: 'var(--size-spacing-04)',
            paddingLeft: 'var(--size-spacing-04)',
          }}
        >
          <Navbar.Section
            fluid
            unbordered
            style={{ gap: 'var(--size-spacing-03)' }}
          >
            <Avatar size="sm" agent={agent} />
            <Text token={Text.tokens.TEXT_MD_BOLD} truncate>
              {agent.name}
            </Text>
          </Navbar.Section>

          <Navbar.Section unbordered>
            <Close />
          </Navbar.Section>
        </Navbar>
        <WidgetWindowMain open={ui.open}>
          <Outlet />
        </WidgetWindowMain>
      </WidgetWindow>

      <WidgetLauncher
        onClick={() => {
          setUI((ui) => ({ ...ui, open: !ui.open }));
        }}
        left={agent.left}
      >
        <Balloon />
        <Indicator>
          <WidgetAvatar size="sm" agent={agent} />
        </Indicator>
      </WidgetLauncher>
    </WidgetContainer>
  );
}
